import React from 'react'

const ContributionTypeBodyTemplate = ({ rowData }) => {
    return rowData.contributionType?.name
}

export default ContributionTypeBodyTemplate
